/// <reference path="../../../../../shared/utils/View.ts"/>
/// <reference path="../../../../../shared/utils/Url.ts"/>
/// <reference path="../../app.d.ts"/>

import { User } from '../../../../../shared/models/api/User/User';
import { BasicUserService } from '../../../../../shared/services/BasicUserService';
import { AppPersistenceService } from '../services/AppPersistenceService';
import { BasicApplicationService } from '../../../../../shared/services/BasicApplicationService';
import { AppApiService } from '../services/AppApiService';
import { BasicApplicationRouter } from '../../../../../shared/services/BasicApplicationRouter';
import { ApplicationPages } from '../Constants';
import { defaults } from '../defaults';
import { AppUtils } from '../../../../../shared/utils/index';

import { PriceCorrectionController } from './steps/PriceCorrectionController';
import { GasStationCorrectionController } from './steps/GasStationCorrectionController';

export class App implements AppController {
	private stepController?: StepController;
	private readonly appPersistanceService: AppPersistenceService;
	private readonly userService: BasicUserService;
	private readonly $ctx: JQuery;
	public readonly options: BasicAppOptions<FuelPricesUserFeedbackAppDefinition>;
	private readonly loader: BasicLoader<FuelPricesUserFeedbackAppDefinition>;
	private readonly applicationService: BasicApplicationService<FuelPricesUserFeedbackAppDefinition>;
	private readonly apiService: AppApiService;
	private readonly applicationRouter: BasicApplicationRouter<FuelPricesUserFeedbackAppDefinition>;
	private readonly idPosInSeoUrl: number;


	constructor(element: HTMLElement | JQuery, options: BasicAppOptions<FuelPricesUserFeedbackAppDefinition>, loader: BasicLoader<FuelPricesUserFeedbackAppDefinition>) {
		this.loader = loader;
		this.options = $.extend(true, {}, defaults, options);
		this.$ctx = this.options.$ctx;

		this.userService = new BasicUserService();
		this.appPersistanceService = new AppPersistenceService(this.options);
		this.applicationService = new BasicApplicationService(this.options);
		this.applicationRouter = new BasicApplicationRouter(this.options);
		this.apiService = new AppApiService(this.options);
		this.idPosInSeoUrl = this.options.app.idposinseourl || 1;
	}

	public start(): void {
		this.callDependencyLoader();
	}

	public callDependencyLoader(): void {
		this.loader._loadDependencies(this.initApplication.bind(this));
	}

	public initApplication(): void {

		AppUtils.View.startLoader();
		this.appPersistanceService.prepareApplicationSession();
		this.userService.getUser((user: User) => {
			const formModel = this.appPersistanceService.getFormModelFromStore();

			if (formModel.GasStation && formModel.GasStation.ID) {
				this.loadStep(user);
			} else {
				this.apiService.retrieveGasStation(this.getGasStationID(),
					(gasStationModel) => {
						formModel.GasStation = gasStationModel;
						this.appPersistanceService.setFormModelToStore(formModel);
						this.loadStep(user);
					},
					(jqxhr, textStatus, errorThrown) => {
						console.error(`Failed to retrieve gas station info: ${errorThrown}`);
						this.applicationRouter.error();
					}
				);
			}
		});
	}

	private loadStep(user: User): void {
		const step = this.applicationService.getCurrentStepName();
		if (ApplicationPages.PriceCorrection === step) {
			this.stepController = new PriceCorrectionController(this, this.options, this.loader, user);
		} else if (ApplicationPages.GasStationCorrection === step) {
			this.stepController = new GasStationCorrectionController(this, this.options, this.loader, user);
		}
		this.stepController.start();
	}

	public afterRenderApp(): void {
		this.loader.initAdditionalModules(this.$ctx);
		AppUtils.View.stopLoader();
		this.loader.complete();
	}

	private getGasStationID(): string {
		let result = AppUtils.Url.getUrlParameter("id");
		if (!result) {
			result = AppUtils.Url.getUrlPathPart(this.idPosInSeoUrl);
		}
		return result;
	}
}
